import HttpHelper from './helper';

export const fawryEndpoints = {
  expressCheckout: (data) => HttpHelper.fawryAxios
    .post(`/init`, data)
    .then((res) => res?.data)
    .catch((err) => err?.response?.data),
};
